/**
 * @module app.cd
 */

import { IMemberSearchFilters } from "app/cd/services/member-service";

export class ContactLogPageContext {

    public memberSearchFilters: IMemberSearchFilters = {};

    public clear(): void {
        this.memberSearchFilters = {};
    }
}
